export default {
    authUser: JSON.parse(sessionStorage.getItem('authUser')) || {},
    authUserLicenseTypes: [],
    orders: [],
    licenseTypes: [],
    pagination: {
        licenseCurrentPage: 1,
    },
    pageTitle: 'ApexO',
};
